import { helper } from '@ember/component/helper';

/**
 * Converte un numero decimale in formato ore:minuti
 * @param {number|string} n - Numero decimale (es: 2.5 -> "2:30") o stringa numerica
 */
function numberToHour([n]) {
  // Converte stringhe numeriche (es: '2.5' o '2,5') in numero. Number() è
  // strict: parseFloat accetterebbe '2.5h'→2.5 e '2,5'→2, e Infinity
  // formatterebbe 'Infinity:NaN'. isFinite scarta Infinity/NaN.
  const normalized = typeof n === 'string' ? n.trim().replace(',', '.') : n;
  const num = typeof normalized === 'string' && normalized !== '' ? Number(normalized) : normalized;
  if (!Number.isFinite(num)) return '0:00';
  const absN = Math.abs(num);
  let hours = Math.floor(absN);
  let minutes = Math.round((absN - hours) * 60);

  // 2.9999 -> minutes rounds to 60: carry into the hour ("3:00", not "2:60")
  if (minutes === 60) {
    hours += 1;
    minutes = 0;
  }
  return `${num < 0 ? '-' : ''}${hours}:${String(minutes).padStart(2, '0')}`;
}
var numberToHour$1 = helper(numberToHour);

export { numberToHour$1 as default, numberToHour };
//# sourceMappingURL=number-to-hour.js.map
